import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import {
  getCorrections,
  takeCorrectionAction,
  clearCorrectionAction,
} from '../lib/api'
import { CorrectionAction, CorrectionActionFilter } from '../types'
import { correctionsKeys } from '../lib/keys'

export const useCorrections = (
  status?: CorrectionActionFilter,
  { enabled } = { enabled: true },
) => {
  return useInfiniteQuery({
    queryKey: correctionsKeys.list(status),
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      getCorrections(pageParam, status),
    getNextPageParam: (lastPage) => lastPage.meta?.nextPage,
    enabled,
  })
}

export const useTakeCorrectionAction = ({
  status,
}: {
  status?: CorrectionActionFilter
}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      correctionId,
      action,
    }: {
      correctionId: number
      action: CorrectionAction
    }) => takeCorrectionAction(correctionId, action),
    onSuccess: () => {
      if (!status || status === CorrectionActionFilter.All) {
        void queryClient.invalidateQueries(correctionsKeys.all)
      } else {
        void queryClient.resetQueries(correctionsKeys.all)
      }
    },
  })
}

export const useClearCorrectionAction = ({
  status,
}: {
  status?: CorrectionActionFilter
}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ correctionId }: { correctionId: number }) =>
      clearCorrectionAction(correctionId),
    onSuccess: () => {
      if (!status || status === CorrectionActionFilter.All) {
        void queryClient.invalidateQueries(correctionsKeys.all)
      } else {
        void queryClient.resetQueries(correctionsKeys.all)
      }
    },
  })
}
